import { CommonModule } from '@angular/common'
import { Component, OnInit } from '@angular/core'
import { AutoBettingConfigDto } from '@rush-core/dtos'
import { FormsModule } from '@angular/forms'
import { AutoBettingService } from '@rush-shared/services'
import { PlayerService } from '@shared/services'

@Component({
  selector: 'app-auto-bet-settings',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './auto-bet-settings.component.html',
  styleUrl: './auto-bet-settings.component.sass',
})
export class AutoBetSettingsComponent implements OnInit {
  constructor(
    public _autoBettingService: AutoBettingService,
    private _playerService: PlayerService,
  ) {}

  tempConfigs: AutoBettingConfigDto[] = []

  get autoBettingIsDisable() {
    return (
      this._autoBettingService.disableAutoBetting || this._playerService.currentSeat !== undefined
    )
  }

  ngOnInit(): void {
    this._autoBettingService.autoBettingConfigs$.observer.subscribe((i) => (this.tempConfigs = i))
  }

  incrementBet(config: any): void {
    if (config.maximumAllowableBet < 100) {
      config.maximumAllowableBet++
    }
  }

  // Method to decrement the maximum bet
  decrementBet(config: any): void {
    if (config.maximumAllowableBet > 0) {
      config.maximumAllowableBet--
    }
  }

  validateBetPercent(config: AutoBettingConfigDto) {
    // if (config.maximumAllowableBet > 100) {
    //   config.maximumAllowableBet = 100
    // } else
    if (config.maximumAllowableBet < 0) {
      config.maximumAllowableBet = 0
    }
  }

  async saveConfig() {
    this._autoBettingService.updateConfigs(this.tempConfigs)
  }

  inputClick(e: any) {
    e.target.select()
  }
}
